import { useCallback, useEffect, useState } from "react";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileLeftSection from "../../Components/MobileLeftSection";
import { useDispatch } from "react-redux";
import {
  DELETE_USER,
  GET_USER_DET,
  LOGOUT,
  UPDATE_USER_DET,
} from "../../Action/UserAction";
import { ListOrders } from "../../Action/OrderPackageAction";
import { Package_List } from "../../Action/PacakgeAction";
import { Student_Validate_Json } from "../../Model/UserModel";
import { useSelector } from "react-redux";
import {
  USER_DELETE_RESET,
  USER_UPDATE_DETAILS_FAILED,
  USER_UPDATE_DETAILS_RESET,
} from "../../Constant/UserConstant";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import Loading from "../../Components/Loading";
import Styles from "./StudentEditDetails.module.css";
import { toast, ToastContainer } from "react-toastify";
import { toastOptions } from "../../Model/ToastEditiorOption";
export default function MobileStudentProfile() {
  const [SideOpener, setSideOpner] = useState(false);
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
  const dispatch = useDispatch();
  const [Hidden, setHidden] = useState({ step1: true, step2: false });
  const [ActiveStep1Btn, setActiveStep1Btn] = useState(false);
  const [ActiveStep2Btn, setActiveStep2Btn] = useState(false);
  const [ProfileDetails, setProfileDetails] = useState({
    First_Name: "",
    Last_Name: "",
    EmailAddress: "",
    PhoneNo: "",
    Gender: "",
    Address: "",
  });

  const {
    loading: loadingD,
    success: successD,
    error: errorD,
  } = useSelector((s) => s.DELETE_USER_REDCUER);

  const { loading, success, error } = useSelector(
    (s) => s.UPDATE_USER_DET_REDUCER
  );

  const { loading: loadingRec, userDetRec } = useSelector(
    (s) => s.GET_USER_DET_REDUCER
  );

  const handleChange = (e) => {
    setProfileDetails({ ...ProfileDetails, [e.target.name]: e.target.value });
  };

  const OpenDeleteModal = (e) => {
    e.preventDefault();
    document.getElementById("deleteModal").classList.add("active");
    document.body.style.overflow = "hidden";
  };

  function closeDeleteModal() {
    document.getElementById("deleteModal").classList.remove("active");
    document.body.style.overflow = "auto";
    // Reset modal state
    goToStep1();
    document.getElementById("confirmationText").value = "";
    document.getElementById("emailConfirmation").value = "";
  }

  function goToStep1() {
    document.getElementById("deleteStep1").classList.remove("hidden");
    document.getElementById("deleteStep2").classList.add("hidden");
    setHidden({ step1: true, step2: false });
    validateStep1();
  }

  const goToStep2 = () => {
    document.getElementById("deleteStep1").classList.add("hidden");
    document.getElementById("deleteStep2").classList.remove("hidden");

    setHidden({ step1: false, step2: true });
    validateStep2();
  };

  function validateStep1() {
    const confirmationText = document.getElementById("confirmationText").value;
    const continueBtn = document.getElementById("continueBtn");
    continueBtn.disabled = confirmationText !== "DELETE MY ACCOUNT";
    if (confirmationText == "DELETE MY ACCOUNT") {
      setActiveStep1Btn(true);
    }
  }

  function validateStep2() {
    const emailConfirmation =
      document.getElementById("emailConfirmation").value;
    const finalDeleteBtn = document.getElementById("finalDeleteBtn");
    finalDeleteBtn.disabled =
      emailConfirmation !== ProfileDetails?.EmailAddress;
    if (emailConfirmation == ProfileDetails?.EmailAddress) {
      setActiveStep2Btn(true);
    }
  }

  function finalDelete() {
    const deleteBtn = document.getElementById("finalDeleteBtn");
    const buttonText = document.getElementById("deleteButtonText");

    // Show loading state
    deleteBtn.disabled = true;
    buttonText.innerHTML =
      '<div className="loading-spinner"></div> Deleting...';

    // Simulate API call
    dispatch(DELETE_USER());
    setTimeout(() => {
      closeDeleteModal();

      // Reset button state
      deleteBtn.disabled = false;
      buttonText.innerHTML = "Delete Account";
    }, 2000);
  }

  // Close modal when clicking outside

  useEffect(() => {
    if (userDetRec) {
      setProfileDetails({ ...userDetRec });
    }
  }, [userDetRec]);

  const handleUpdate = () => {
    const Validate = Student_Validate_Json({ ...ProfileDetails });

    if (Validate === "success") {
      dispatch(UPDATE_USER_DET({ ...ProfileDetails }));
    } else {
      dispatch({ type: USER_UPDATE_DETAILS_FAILED, payload: Validate });
    }
  };

  const handleCancel = () => {
    dispatch({ type: USER_UPDATE_DETAILS_RESET });
  };

  const get_Packages = useCallback(() => {
    dispatch(Package_List({ page_size: 10, page_no: 1 }, "MainPackages"));
  }, [dispatch]);

  useEffect(() => {
    get_Packages();
  }, [get_Packages]);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        handleCancel();
      }, 5000);
    }
  }, [success, dispatch]);

  useEffect(() => {
    dispatch(ListOrders());
    dispatch(GET_USER_DET());
  }, [dispatch]);

  useEffect(() => {
    if (successD) {
      toast.success(successD, toastOptions);
      setTimeout(() => {
        dispatch(LOGOUT());
      }, 5000);
    }

    if (errorD) {
      toast.error(errorD, toastOptions);
    }
    setTimeout(() => {
      dispatch({ type: USER_DELETE_RESET });
    }, 4000);
  }, [successD, errorD]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //   document
  //     .getElementById("deleteModal")
  //     .addEventListener("click", function (e) {
  //       if (e.target === this) {
  //         closeDeleteModal();
  //       }
  //     });

  //   // Prevent modal close when clicking inside modal content
  //   document.querySelector(".modal").addEventListener("click", function (e) {
  //     e.stopPropagation();
  //   });
  // }, []);

  return (
    <>
      {loading || loadingRec ? <Loading /> : ""}
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} />
        <div className="main-content">
          <MobileHeaderSection Page="Profile" OpenSideMenu={OpenSideMenu} />
          <div className="Profile_Page">
            <div className="profile-header">
              <div className="profile-content">
                <div className="profile-avatar">
                  <img
                    src="/assets/image/user.svg"
                    alt="Profile"
                    className="avatar-image"
                  />
                </div>
                <h2
                  className="profile-name"
                  style={{ padding: "0", margin: "0" }}
                >
                  {userDetRec?.First_Name
                    ? userDetRec?.First_Name + " " + userDetRec?.Last_Name
                    : "New User"}
                </h2>
                <p
                  style={{ padding: "0", margin: "0" }}
                  className="profile-email"
                >
                  {userDetRec?.EmailAddress}
                </p>
              </div>
            </div>

            {/* <!-- Personal Information Card --> */}
            <div className="info-card">
              <div className="card-content">
                <h3 className="section-title">Personal Information</h3>

                <div className="form-fields">
                  <div className="field-group">
                    <label className="field-label">First Name</label>
                    <input
                      type="text"
                      className="field-input"
                      placeholder="First Name"
                      name="First_Name"
                      value={ProfileDetails?.First_Name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="field-group">
                    <label className="field-label">Last Name</label>
                    <input
                      type="text"
                      className="field-input"
                      placeholder="First Name"
                      name="Last_Name"
                      value={ProfileDetails?.Last_Name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="field-group">
                    <label className="field-label">Phone Number</label>
                    <input
                      type="number"
                      className="field-input"
                      placeholder="Phone No"
                      name="PhoneNo"
                      value={ProfileDetails?.PhoneNo}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="field-group">
                    <label className="field-label">Email Address</label>
                    <input
                      type="email"
                      className="field-input"
                      placeholder="Email Address"
                      name="EmailAddress"
                      value={ProfileDetails?.EmailAddress}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="field-group">
                    <label className="field-label">Gender</label>
                    <div className="select-wrapper">
                      <select
                        className="field-select"
                        name="Gender"
                        value={ProfileDetails?.Gender}
                        onChange={handleChange}
                      >
                        <option value={""}>Select Your Gender</option>
                        <option value={"male"}>Male</option>
                        <option value={"female"}>Female</option>
                        <option value={"other"}>Other</option>
                      </select>
                      <div className="select-arrow">
                        <svg
                          width="12"
                          height="8"
                          viewBox="0 0 12 8"
                          fill="none"
                        >
                          <path
                            d="M1 1.5L6 6.5L11 1.5"
                            stroke="#6B7280"
                            strokeWidth="1.5"
                            stroke-linecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={Styles.ErrorSuccessMsg}>
                  {error ? (
                    <p style={{ color: "red", textAlign: "center" }}>{error}</p>
                  ) : success ? (
                    <p style={{ color: "green", textAlign: "center" }}>
                      {success}
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                <button
                  className="update-button"
                  onClick={() => handleUpdate()}
                >
                  Update Profile
                </button>
              </div>
            </div>

            {/* <!-- Danger Zone --> */}
            <div className="Profile_Danger">
              <div className="danger-zone">
                <div className="danger-header">
                  <div className="danger-icon">⚠</div>
                  <h3 className="danger-title">Danger Zone</h3>
                </div>

                <div>
                  <h4 className="delete-section-title">Delete Account</h4>
                  <p className="delete-description">
                    Once you delete your account, there is no going back. This
                    action cannot be undone. All your data, including profile
                    information, preferences, and history will be permanently
                    removed.
                  </p>

                  <button className="btn btn-danger" onClick={OpenDeleteModal}>
                    <svg className="icon" viewBox="0 0 24 24">
                      <polyline points="3,6 5,6 21,6"></polyline>
                      <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
                    </svg>
                    Delete Account
                  </button>
                </div>
              </div>
            </div>
          </div>
          <MobileBottomMenu Page="Profile" />
        </div>
      </div>

      {/* <!-- Delete Account Modal --> */}
      <div className="Profile_Danger">
        <div className="modal-overlay" id="deleteModal">
          <div className="modal">
            <button className="modal-close" onClick={() => closeDeleteModal()}>
              ×
            </button>

            {/* <!-- Step 1: Initial Confirmation --> */}
            <div id="deleteStep1" className={Hidden?.step1 ? "kl" : "hidden"}>
              <div className="modal-header">
                <div className="danger-icon">⚠</div>
                <h3 className="modal-title">Delete Account</h3>
              </div>

              <div className="modal-content">
                <p style={{ color: "#374151", marginBottom: "16px" }}>
                  Are you absolutely sure you want to delete your account? This
                  action will:
                </p>

                <ul className="warning-list">
                  <li>Permanently delete all your personal information</li>
                  <li>Remove all your saved preferences and settings</li>
                  <li>Delete your account history and activity</li>
                  <li>Cancel any active subscriptions or memberships</li>
                  <li>Make your account completely unrecoverable</li>
                </ul>

                <div className="warning-box">
                  <p className="warning-text">
                    ⚠️ This action is permanent and cannot be undone
                  </p>
                </div>

                <div style={{ marginTop: "20px" }}>
                  <label className="form-label">
                    Type "DELETE MY ACCOUNT" to confirm:
                  </label>
                  <input
                    type="text"
                    className="confirmation-input"
                    placeholder="DELETE MY ACCOUNT"
                    id="confirmationText"
                    onInput={() => validateStep1()}
                  />
                </div>

                <div className="modal-actions">
                  <button
                    className="btn btn-secondary"
                    onClick={() => closeDeleteModal()}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-danger"
                    id="continueBtn"
                    disabled={ActiveStep1Btn ? false : true}
                    onClick={() => goToStep2()}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>

            {/* <!-- Step 2: Final Confirmation --> */}
            <div id="deleteStep2" className={Hidden?.step1 ? "hidden" : "klo"}>
              <div className="modal-header">
                <div className="danger-icon">⚠</div>
                <h3 className="modal-title">Final Confirmation</h3>
              </div>

              <div className="modal-content">
                <p style={{ color: "#374151", marginBottom: "16px" }}>
                  As a final security measure, please enter your email address
                  to confirm account deletion:
                </p>

                <div className="warning-box-yellow">
                  <p className="warning-text-yellow">
                    <strong>Last chance:</strong> After clicking "Delete
                    Account", your data will be permanently removed within 24
                    hours.
                  </p>
                </div>

                <div style={{ marginTop: "20px" }}>
                  <label className="form-label">
                    Confirm your email address:
                  </label>
                  <input
                    type="email"
                    className="confirmation-input"
                    placeholder="confirm email"
                    id="emailConfirmation"
                    onInput={() => validateStep2()}
                  />
                </div>

                <div className="modal-actions">
                  <button
                    className="btn btn-secondary"
                    onClick={() => goToStep1()}
                  >
                    Back
                  </button>
                  <button
                    className="btn btn-danger"
                    id="finalDeleteBtn"
                    disabled={!ActiveStep2Btn || loadingD ? true : false}
                    onClick={() => finalDelete()}
                  >
                    <svg className="icon" viewBox="0 0 24 24">
                      <polyline points="3,6 5,6 21,6"></polyline>
                      <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
                    </svg>
                    <span id="deleteButtonText">Delete Account</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
}
